import React, { useEffect, useRef } from "react";

const LocationAutocomplete = ({ name, value, onChange, countryRestrictions = ["de", "be", "fr", "nl", "pl"] }) => {
  const inputRef = useRef(null);
  const latRef = useRef(null);
  const lngRef = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API not loaded");
      return;
    }

    const options = {
      types: ["(regions)"],
      componentRestrictions: { country: countryRestrictions },
    };

    const fixZIndex = () => {
      const pacContainer = document.querySelector('.pac-container');
      if (pacContainer) {
        pacContainer.style.zIndex = '1060';
      }
    };

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, options);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      onChange({
        target: {
          name,
          value: place.formatted_address,
          lat,
          lng,
        },
      });

      if (latRef.current) latRef.current.value = lat;
      if (lngRef.current) lngRef.current.value = lng;
    });

    setTimeout(fixZIndex, 100);
    
  }, [name, onChange, countryRestrictions]);

  return (
    <div className="mb-3">
      <input
        type="text"
        ref={inputRef}
        className="form-control"
        name={name}
        value={value || ''} 
        onChange={(e) => {
          onChange({
            target: {
              name,
              value: e.target.value
            }
          });
        }}
        placeholder="Enter postal code or address"
      />
      <input type="hidden" ref={latRef} name={`${name}_lat`} />
      <input type="hidden" ref={lngRef} name={`${name}_lng`} />
    </div>
  );
};

export default LocationAutocomplete;